import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { authGuard } from './guard/auth.guard';
import { AuthKeycloakGuard } from './guard/keycloack-auth.guard';


const routes: Routes = [
    { path: '', pathMatch: 'full', redirectTo: 'myTask' },
    { path: 'myTask', loadChildren: async () => (await import('./my-task/my-task.module')).MyTaskModule, canActivate: [authGuard] },
    { path: 'profileReview', loadChildren: async () => (await import('./profile-review/profile-review.module')).ProfileReviewModule, canActivate: [authGuard] },
    { path: 'activities', loadChildren: async () => (await import('./activity/activity.module')).ActivityModule, canActivate: [authGuard] },
    { path: 'cadre-role-configuration', loadChildren: async () => (await import('./cadre-role-configuration/cadre-role-configuration.module')).CadreRoleConfigurationModule, canActivate: [authGuard] },
    { path: 'activityConfiguration', loadChildren: async () => (await import('./activity-configuration/activity-configuration.module')).ActivityConfigurationModule, canActivate: [authGuard] },
    { path: 'master', loadChildren: async () => (await import('./master/master.module')).MasterModule, canActivate: [authGuard] },
    { path: 'cadre-payment', loadChildren: async () => (await import('./cadre-payment/cadre-payment.module')).CadrePaymentModule, canActivate: [authGuard] },
    { path: 'reports', loadChildren: async () => (await import('./reports/reports.module')).ReportsModule, canActivate: [authGuard] },
];

@NgModule({
    imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: 'top' })],
    exports: [RouterModule]
})
export class AppRoutingModule { }
